import React from 'react'
import './Modal.scss'

import Image from '../Assets/image.png'

function Modal(props){
    console.log(props)
    return(
        <div className={props.darkMode ? "modal_window dark" : "modal_window" } style={{ display: props.modalWindow ? 'block' : 'none' }}>
            <div className="window_content">
                <div className="close_modal" >
                    <button onClick={() => props.setModalWindow(!props.modalWindow)}>×</button>
                </div>
                <h1>Register your NFT event</h1>
                <div className="image">
                    <p>Logo image</p>
                    <span>This image will also be used for nsvigation. 350 x 350 recommended.</span>
                    <img src={Image} alt="img_upload" />
                </div>
                <div className="name">
                    <label>Name</label>
                    <input></input>
                </div>
                <div className="url">
                    <label>URL</label>
                    <input></input>
                    <span>Customize your URL on MeDIA eYe. Must only contain lowercase letters, numbers, and hyphens.</span>
                </div>
                <p>Schedule your NTF event</p>
                <div className="date">
                    <div><label>Date</label> <input/></div>
                    <div><label>Month</label> <input/></div>
                    <div><label>Year</label> <input/></div>
                </div>
                <div className="description">
                    <label>Description</label>
                    <input></input>
                </div>
                <button>Registration</button>
                <div className="charity">
                    <span>Please allow up to 24 hours to moderate your charity</span>
                </div>
            </div>
        </div>
    )
}

export default Modal;